import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { DEFAULT_LANGUAGE, LANGUAGE_CODES, languageInfo } from "./languages";
import en from "./locales/en.json";
import zh from "./locales/zh.json";
import hi from "./locales/hi.json";
import es from "./locales/es.json";
import ar from "./locales/ar.json";
import fr from "./locales/fr.json";
import vi from "./locales/vi.json";

// English is the source. Every other file is a machine draft until a fluent
// reviewer signs it off — see each file's _meta block and memory/I18N.md.
export const resources = {
  en: { translation: en },
  zh: { translation: zh },
  hi: { translation: hi },
  es: { translation: es },
  ar: { translation: ar },
  fr: { translation: fr },
  vi: { translation: vi },
};

// Keep <html lang> and <html dir> in step, so screen readers pick the right
// voice and Arabic lays out right-to-left.
const applyDocumentLanguage = (lng) => {
  if (typeof document === "undefined") return;
  const info = languageInfo(lng);
  document.documentElement.lang = info.code;
  document.documentElement.dir = info.dir;
};

i18n.on("languageChanged", applyDocumentLanguage);

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: DEFAULT_LANGUAGE,
    supportedLngs: LANGUAGE_CODES,
    nonExplicitSupportedLngs: true, // es-MX → es
    load: "languageOnly",
    returnNull: false,
    interpolation: { escapeValue: false }, // React already escapes
    detection: {
      // A choice made on this device wins, then the browser's language.
      // Signed-in users' saved choice is applied after /auth/me (AuthContext).
      order: ["localStorage", "navigator"],
      lookupLocalStorage: "vale.lang",
      caches: ["localStorage"],
    },
  });

export default i18n;
